import { useState, useEffect } from 'react';

export type LayoutMode = 'desktop' | 'tablet' | 'mobile';

export function useLayout(): { mode: LayoutMode; width: number; height: number } {
  const [layout, setLayout] = useState(() => getLayout());

  useEffect(() => {
    const onResize = () => setLayout(getLayout());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return layout;
}

function getLayout() {
  const width = window.innerWidth;
  const height = window.innerHeight;
  const mode: LayoutMode = width >= 1024 ? 'desktop' : width >= 640 ? 'tablet' : 'mobile';
  return { mode, width, height };
}
